/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import InputText from './InputText';
import InputCheckbox from './InputCheckbox';
import InputSelect from './InputSelect';

const TransferCustomDetails = function ({ customDetails, targetId }) {
  return customDetails
    .map(({
      fieldType,
      field,
      mandatory,
      fieldOptions,
      target,
      helpMessage,
      fallbackValue,
    }) => {
      const properties = {
        id: field.replace(/\W+/g, ''),
        name: field,
        target,
        required: mandatory,
        hidden: target && target !== targetId,
        defaultValue: fallbackValue,
        helpMessage,
      };
      switch (fieldType) {
        case 'input':
          return <InputText {...properties} />;
        case 'number':
          return <InputText type="number" {...properties} />;
        case 'checkbox':
          return <InputCheckbox {...properties} />;
        case 'radio':
        case 'select': {
          const options = fieldOptions.map(
            ({ field: label }) => ({ label, value: label }),
          );
          return <InputSelect options={options} {...properties} />;
        }
        default:
          return undefined;
      }
    });
};

export default TransferCustomDetails;
